import { render, staticRenderFns } from "./GoodsRecommend.vue?vue&type=template&id=427ce1a4&scoped=true"
import script from "./GoodsRecommend.vue?vue&type=script&lang=js"
export * from "./GoodsRecommend.vue?vue&type=script&lang=js"
import style0 from "./GoodsRecommend.vue?vue&type=style&index=0&id=427ce1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427ce1a4",
  null
  
)

export default component.exports